export default __webpack_public_path__ + "static/media/FastRealtyLogo.26bc63e5.png";